import type { CalendarDate } from '@domain/value-objects/CalendarDate';
import type { DateRange } from '@domain/value-objects/DateRange';
import type { PermissionRequestStatus } from '@domain/vocabulary';

/**
 * Qué permisos siguen en el tablero.
 *
 * Lo pidió JC el 21 oct 2026 con una captura: el tablero de permisos guardaba
 * todo para siempre —aprobados de agosto, rechazados de septiembre, un cancelado—
 * y a esa fecha seis de sus ocho tarjetas eran de días que ya habían pasado. El
 * de vacaciones no se llena así: una aprobada pasa a «Tomada» cuando termina y
 * sale del tablero.
 *
 * La misma regla aquí: **lo decidido se va cuando termina su último día**; el día
 * mismo todavía se ve. **Lo que espera decisión se queda siempre**, aunque sus
 * fechas hayan pasado, igual que en vacaciones: es trabajo del líder, y
 * esconderlo lo dejaría pendiente para siempre.
 */
export interface PermitCard {
  readonly status: PermissionRequestStatus;
  readonly range: DateRange;
}

export const stillOnPermitBoard = (card: PermitCard, today: CalendarDate): boolean =>
  card.status === 'Por aprobar' || !card.range.end.isBefore(today);
